/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Match_AnyInputs */

const cs_demands_match_any = /** @type {(inputs: Demands_Match_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny poptávky`)
};

const en_demands_match_any = /** @type {(inputs: Demands_Match_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All demands`)
};

/**
* | output |
* | --- |
* | "All demands" |
*
* @param {Demands_Match_AnyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_match_any = /** @type {((inputs?: Demands_Match_AnyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Match_AnyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_match_any(inputs)
	return cs_demands_match_any(inputs)
});